<div
    dir="ltr"
    class="gap-[24px] flex   flex-row rounded-br-[24px] rounded-bl-[24px] shrink-0 justify-between items-center pl-[64px] pr-[64px] pt-[24px] pb-[24px] bg-[#ff6900ff] w-[100%] relative">
    <div class="gap-[10px] flex cursor-pointer flex-col shrink-0 justify-start items-start">
      <a routerLink="/programs" class="cursor-pointer focus:outline-none flex flex-row items-center gap-2" [attr.aria-label]="'BakerRipley home'">
        <img
          *ngIf="useCompactLogo"
          src="assets/icons/Bakerriplylogo_1.svg"
          alt="BakerRipley logo"
          loading="eager"
          decoding="async"
          fetchpriority="high"
          class="w-[35px] h-[38px] shrink-0"
        />
        <img
          *ngIf="!useCompactLogo"
          src="assets/icons/Bakerriply_logo_1.svg"
          alt="BakerRipley logo"
          loading="eager"
          decoding="async"
          fetchpriority="high"
          class="w-[214px] h-[40px] shrink-0 justify-start items-start bg-transparent text-white"
        />
        <span
          *ngIf="useCompactLogo && programName"
          class="text-white font-['archivo'] font-bold text-[20px] leading-[24px] whitespace-nowrap"
        >
          {{ programName }}
        </span>
      </a>
    </div>
    <div class="gap-[24px] flex flex-row shrink-0 justify-end items-center">
        <span class="shrink-0 justify-start items-start text-[#ffffffff] text-right font-medium font-['archivo'] fontWeight-[500]  text-[20px] leading-[22px]">
          {{ todayDate }}
        </span>

        <!-- Location chip: click to switch centers without signing out -->
        <button
          *ngIf="selectedLocationName"
          type="button"
          class="flex flex-row items-center gap-[6px] bg-white/20 hover:bg-white/30 rounded-full px-[14px] py-[8px] border-0 cursor-pointer"
          title="Switch center"
          aria-label="Switch working center"
          [disabled]="isRefreshingLocations"
          (click)="openLocationSwitcher($event)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-[16px] h-[16px] text-white shrink-0" viewBox="0 0 24 24" fill="currentColor">
            <path fill-rule="evenodd" d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-2.034 3.048-4.152 3.048-6.327C19.337 8.27 16.026 5 12 5s-7.337 3.27-7.337 7.001c0 2.175 1.104 4.293 3.048 6.327a19.579 19.579 0 002.683 2.282 16.974 16.974 0 001.144.742zM12 13.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" clip-rule="evenodd" />
          </svg>
          <span class="text-white font-['archivo'] font-semibold text-[15px] leading-[22px] whitespace-nowrap">
            {{ selectedLocationName }}
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-[14px] h-[14px] text-white shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
          </svg>
        </button>

        <NiAutocomplete
            *ngIf="showFinancialYearFilter"
            [(selected)]="selectedFinancialYear"
            [options]="financialYearOptions"
            [openOnClick]="true"
            [dropdown]="true"
            [dropdownMode]="'current'"
            [valueField]="'value'"
            [optionLabel]="'label'"
            [label]="''"
            width="180px"
            [placeholder]="allYearsPlaceholder"
            [fluid]="true"
            inputStyle="background-color: white; border: none; box-shadow: none; border-radius: 30px; width: 140px; height: 52px; color: #000000; padding-top: 12px; padding-bottom: 12px; font-archivo"
            (onSelect)="onFinancialYearSelect($event)">
        </NiAutocomplete>

        <NiAutocomplete 
            [(selected)]="selectedCountry" 
            [options]="countries"
            [openOnClick]="true"
            [dropdown]="true"
            [dropdownMode]="'blank'"
            [valueField]="'value'"
            [label]="''" 
            width="200px"
            [placeholder]="''"
            [fluid]="true"
            [readonly]="false"
            inputStyle="background-color: white; border: none; box-shadow: none; border-radius: 30px; width: 121px; height: 52px; color: #000000; padding-top: 12px; padding-bottom: 12px; font-archivo"
            (onSelect)="onSelectBasicSelect($event)">
          </NiAutocomplete>

        <button
          *ngIf="showProfileMenu"
          type="button"
          class="flex items-center justify-center w-[52px] h-[52px] rounded-full bg-white/20 hover:bg-white/30 cursor-pointer border-0 shrink-0"
          (click)="logout($event)"
          (keydown.enter)="logout($event)"
          [title]="logoutLabel"
          [attr.aria-label]="logoutLabel">
          <NiIcon icon="logout" iconClass="!w-[1.5rem] !h-[1.5rem] brightness-0 invert" />
        </button>
        
        </div>
</div>

<app-location-selection-modal
  [isOpen]="showLocationSwitcher"
  [locations]="switchLocations"
  [allowCancel]="true"
  [title]="'Switch Center'"
  [description]="'Choose the center you are working at. You stay signed in.'"
  [continueLabel]="'Switch'"
  [initialLocationId]="selectedLocationId"
  (locationSelected)="onLocationSwitchConfirmed($event)"
  (cancelled)="onLocationSwitchCancelled()"
></app-location-selection-modal>

<NiFormToaster
  *ngFor="let toast of toasts"
  [message]="toast.message"
  [type]="toast.type"
  [position]="toast.position || 'top-right'"
  (onClose)="toasterService.remove(toast.id)"
></NiFormToaster>

